import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/data/business";

const DEFAULT_OG = `${SITE_URL}/van.jpg`;

export default function SEO({ title, description, path = "/", image, jsonLd = [], type = "website" }) {
  const clean = path === "/" ? "/" : `/${encodeURI(path.replace(/^\/+/, ""))}`;
  const canonical = `${SITE_URL}${clean}`;
  const img = image || DEFAULT_OG;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path === "/" ? "/" : `/${encodeURI(it.path.replace(/^\/+/, ""))}`}`,
  })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const serviceLd = (s) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: s.name,
  serviceType: s.name,
  description: s.description,
  provider: { "@id": `${SITE_URL}/#business` },
  areaServed: { "@type": "City", name: "الرياض" },
  url: `${SITE_URL}/${encodeURI(s.slug)}`,
});
